import Text14 from '@sdk/components/ui/typography/Text14';
import gettext from '@sdk/lang/gettext';
import Row from '@sdk/components/ui/spacing/Row';
import Column from '@sdk/components/ui/spacing/Column';
import formatTime from '@sdk/utils/dateFormat/formatTime';
import TranslateWithComponents from '@sdk/lang/TranslateWithComponents';
import { ThemeColorType } from '@sdk/theme/ThemeColorType';
import type { TimesheetHistoryTimeEntry } from '@sdk/timesheets/types/TimesheetHistory';
import useAuth from '@sdk/authentication/useAuth';

import getBreakName from '@web/timeClock/utils/getBreakName';

type Props = {
  editedChange: TimesheetHistoryTimeEntry;
};

const TimesheetHistoryRowsForAddedEntry = ({ editedChange }: Props) => {
  const { currentUser } = useAuth();

  return (
    <>
      <Text14 themeColor={ThemeColorType.gray} mTop={5}>
        {gettext('Added time entry')}
      </Text14>

      <Row>
        <Text14 themeColor={ThemeColorType.gray}>
          <TranslateWithComponents
            replaceComponents={{
              time: (
                <Text14 themeColor={ThemeColorType.success}>
                  {formatTime(editedChange.clockInTo, currentUser.settings.usTimeFormat)}
                </Text14>
              ),
            }}>
            {gettext('In [[time]]')}
          </TranslateWithComponents>
        </Text14>
        {editedChange.clockOutTo && (
          <Text14 themeColor={ThemeColorType.gray}>
            {'\xa0'}
            <TranslateWithComponents
              replaceComponents={{
                time: (
                  <Text14 themeColor={ThemeColorType.success}>
                    {formatTime(editedChange.clockOutTo, currentUser.settings.usTimeFormat)}
                  </Text14>
                ),
              }}>
              {gettext('Out [[time]]')}
            </TranslateWithComponents>
          </Text14>
        )}
      </Row>

      {!!editedChange.breaks.length &&
        editedChange.breaks.map((breakObj, index) => {
          return (
            <Column key={index}>
              <Text14 themeColor={ThemeColorType.gray} mTop={5}>
                {gettext('Added %(breakName)s', {
                  breakName: getBreakName(breakObj.type),
                })}
              </Text14>
              <Row>
                <Text14 themeColor={ThemeColorType.gray}>
                  <TranslateWithComponents
                    replaceComponents={{
                      time: (
                        <Text14 themeColor={ThemeColorType.success}>
                          {formatTime(breakObj.endTo, currentUser.settings.usTimeFormat)}
                        </Text14>
                      ),
                    }}>
                    {gettext('Start [[time]]')}
                  </TranslateWithComponents>
                </Text14>
                {breakObj.endTo && (
                  <Text14 themeColor={ThemeColorType.gray}>
                    {'\xa0'}
                    <TranslateWithComponents
                      replaceComponents={{
                        time: (
                          <Text14 themeColor={ThemeColorType.success}>
                            {formatTime(breakObj.endTo, currentUser.settings.usTimeFormat)}
                          </Text14>
                        ),
                      }}>
                      {gettext('End [[time]]')}
                    </TranslateWithComponents>
                  </Text14>
                )}
              </Row>
            </Column>
          );
        })}
    </>
  );
};

export default TimesheetHistoryRowsForAddedEntry;
